import { ENTITY_LABELS } from "../../utils/labelMapping";

// A function, not a static array, so names re-resolve from ENTITY_LABELS on every call
// (a module-level array would freeze on whichever customer's labels loaded first).
export function getMetricOptions() {
  return [
    { name: "Rank", value: "rank" },
    { name: "Sentiment", value: "sentiment" },
    { name: ENTITY_LABELS.brandPillar, value: "coreAttribute" },
    { name: ENTITY_LABELS.purchaseCriteria, value: "categoryDimension" },
    { name: "Brand Attributes", value: "signalStrength" },
    { name: "Open Ended Questions", value: "nonBrandedQuestions" },
    { name: "Fact Based Questions", value: "factBasedQuestions" },
  ];
}

// "nonBrandedQuestions"/"factBasedQuestions" are opt-in (gated by customer_ui_info.is_non_branded_questions)
// so they're excluded from the "select everything" default — must be explicitly chosen to run.
const OPT_IN_METRICS = ["nonBrandedQuestions", "factBasedQuestions"];
export const ALL_METRIC_VALUES = getMetricOptions()
  .map((m) => m.value)
  .filter((value) => !OPT_IN_METRICS.includes(value));
